const simpleSearchStyle = {
  formControl: {
    margin: "8px",
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: "8px",
  },
  container1: {
    display: "inline-flex",
    gridColumnGap: "0.2em",
    alignItems: "center",
    justifyItems: "center",
    flexFlow: "row wrap",
    gridGap: "8px",
    marginTop: "1em",
    marginBottom: "1em",
  },
  searchBox: { 
    display: "flex", 
    flexDirection: "row" ,
    marginTop: '2px',
  },
  itemGrid1: { width: "170px" },
  itemGrid2: {
    margin: "0 1em 0 -1em",
  }
  ,
  navigateButton: {
    margin: "0.2em 0.3em 0em 0em",
    width: "20px",
    minWidth: "20px",
    height: "20px",
  },
  cancelButton: {
    margin: "0.2em 0.3em 0em 0em",
    width: "30px",
    minWidth: "30px",
    height: "30px",
  },
  searchBtn: {
    margin: " 0.2em 0.3em 0em 0em",
    width: "30px",
    minWidth: "30px",
    height: "30px",
    backgroundColor: '#91C73C',
  },
  advanceBtn: {
    margin: "0.2em 0.2em 0em 0em",
    width: "30px",
    minWidth: "30px",
    height: "30px",
  },
  selectFormControl: {
    paddingTop: "1em",
  },
  selectField: {
    color: "#d2d2d2",
    fontSize: " 0.83rem",
    padding: "0px 0px",
  },
  optionField: {
    color: "black",
    fontSize: "0.83rem",
  },
  inputSearch: {
    color: "#d2d2d2",
    margin: "0.4em 0.4em 0em 0em",
    fontSize: '0.83rem',
    '& .MuiInputBase-input::placeholder': {
      color: '#d2d2d2'
    }
  },
  searchResult: {
    color: "#d2d2d2",
    fontSize: " 0.83rem",    
    marginRight: "15px",
    cursor: "default",
    paddingTop: "2px",
  },
  scrollButton: {
    cursor: "pointer"
  }
};
export default simpleSearchStyle;
